export default [ {
  path: '/projects',
  name: 'Projects',
  meta: {
    title: 'TabTitle.projects',
  },
  component: () => import('@/pages/projects.vue'),
} ];
